import React from "react";
import { TurnrGrid } from "~/components/TurnrGrid.jsx";

export function InputGridWrapper(props) {
    return (
        <TurnrGrid {...props} item xs={12}>
            {props.children}
        </TurnrGrid>
    );
}

export function SettingsContainerWrapper({ children }) {
    return (
        <TurnrGrid container item spacing={2} xs={12} direction="row">
            {children}
        </TurnrGrid>
    );
}
